// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';

import SidebarList from './SidebarList';
import ChatForm from './ChatForm';
import NewSupportForm from './NewSupportForm';

const S = {
  Wrapper: styled.div`
    margin-top: 32px;
    margin-bottom: 37px;
    display: flex;
    flex-grow: 1;
    height: 100%;
    width: 100%;
    max-height: calc(100vh - 190px);
    justify-content: center;
  `,
  ChatForm: styled(ChatForm)`
    flex-grow: 1;
    max-width: 820px;
  `,
  NewSupportForm: styled(NewSupportForm)`
    flex-grow: 1;
    max-width: 820px;
  `,
  SidebarList: styled(SidebarList)`
    margin-right: 22px;
    flex-shrink: 0;
  `,
  LoadingContainer: styled.div`
    display: flex;
    flex-grow: 1;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: center;
  `,
};

export { S as default };

